// extracted by mini-css-extract-plugin
module.exports = {"location":"location_location___76Hn","image":"location_image__IdYpx","title":"location_title__VTjai","count":"location_count__t0Zvm"};